export const CHANGE_VISIBLE_AUTH_FORM = 'CHANGE_VISIBLE_AUTH_FORM';
